import { Injectable } from "@angular/core";

declare var require: any;

@Injectable()
export class UtilsService {

  /*** GET DATE ONLY */
  removeTime(date: Date): Date {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  /** SET GRAPHE LANG **/
  setHighChartsLang(Highcharts) {
    Highcharts.setOptions({
      lang: {
        printChart: 'Imprimer',
        thousandsSep: ',',
        months: [
          'Janvier', 'Février', 'Mars', 'Avril',
          'Mai', 'Juin', 'Juillet', 'Août',
          'Septembre', 'Octobre', 'Novembre', 'Décembre'
        ],
        weekdays: [
          'Dimanche', 'Lundi', 'Mardi', 'Mercredi',
          'Jeudi', 'Vendredi', 'Samedi'
        ],
        shortMonths: ['Jan', 'Fév', 'Mars', 'Avr', 'Mai', 'Jui', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'],
        downloadPNG: 'Télécharger image PNG',
        downloadJPEG: 'Télécharger image JPEG',
        downloadPDF: 'Télécharger image PDF',
        downloadSVG: 'Télécharger image SVG',
        drillUpText: '◁ Retour',
        viewFullscreen: 'Voir en plein écran'
      }
    });
  }

  setHighchartsFactory() {
    let hc = require("highcharts");
    const hcm = require("highcharts/highcharts-3d");
    const exp = require("highcharts/modules/exporting");
    const exd = require("highcharts/modules/export-data");
    const off = require("highcharts/modules/offline-exporting");
    const sg = require("highcharts/modules/solid-gauge");
    const hm = require("highcharts/highcharts-more");
    const st = require("highcharts/modules/stock");
    const dn = require("highcharts/modules/drilldown");
    const tn = require("highcharts/modules/timeline");
    const sk = require("highcharts/modules/sankey");
    const on = require("highcharts/modules/organization");

    hcm(hc);
    exp(hc);
    exd(hc);
    off(hc);
    sg(hc);
    st(hc);
    hm(hc);
    dn(hc);
    tn(hc);
    sk(hc);
    on(hc);
  }

}
